import { render, staticRenderFns } from "./FormSetting.vue?vue&type=template&id=689042d9&scoped=true"
import script from "./FormSetting.vue?vue&type=script&lang=js"
export * from "./FormSetting.vue?vue&type=script&lang=js"
import style0 from "./FormSetting.vue?vue&type=style&index=0&id=689042d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689042d9",
  null
  
)

export default component.exports